import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'status-upload-two',
  templateUrl: './status-upload-two.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryStatusUploadTwoComponent implements OnInit {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  innerContent = {
    subTitle:
      'If you have finished taking photos, uploading them, and deleting them from your device, mark this complete and move to the next step. ',
  };

  ngOnInit(): void {
    this.innerContent[
      'title'
    ] = `Mark <span class="font-bold text-[#25508E]"> Uploads Part 2 </span> for  <span class="font-bold text-[#25508E]"> ${this.data?.path_name} </span> complete?`;
  }

  previousNextStatusEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }
}
